import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Chip, Typography, useTheme } from "@mui/material";
import { applyTokens } from "../../../utilities/applyTokens.js";
function AtlasSeverityIndicator({ label, color }) {
    const { tokens: { component: { statusIndicator: { severityIndicator }, }, }, } = useTheme();
    return (_jsxs(Box, Object.assign({ sx: {
            display: "flex",
            gap: severityIndicator.gap.value,
            alignItems: "center",
        } }, { children: [_jsx(Chip, { sx: Object.assign(Object.assign({}, applyTokens(severityIndicator.badge[color])), applyTokens(severityIndicator.badge)) }), _jsx(Typography, Object.assign({ sx: Object.assign({}, applyTokens(severityIndicator.label)) }, { children: label }))] })));
}
function statusIndicatorColorStyles(color, tokens) {
    if (Object.keys(tokens.colors).includes(color)) {
        return Object.assign({}, applyTokens(tokens.colors[color]));
    }
    if (Object.keys(tokens.qualitative).includes(color)) {
        return Object.assign({}, applyTokens(tokens.qualitative[color]));
    }
    if (Object.keys(tokens.sequential).includes(color)) {
        return Object.assign({}, applyTokens(tokens.sequential[color]));
    }
}
function AtlasStatusIndicator(_a) {
    var { color } = _a, props = __rest(_a, ["color"]);
    const { tokens: { component: { statusIndicator }, }, } = useTheme();
    const statusIndicatorStyles = Object.assign(Object.assign(Object.assign({}, applyTokens(statusIndicator)), { "&:has(.MuiChip-icon)": Object.assign({}, applyTokens(statusIndicator.withIcon)), "&:has(.MuiChip-icon):has(.MuiChip-label:empty)": Object.assign(Object.assign({}, applyTokens(statusIndicator.iconOnly)), { gap: 0 }), "& .MuiChip-label": Object.assign({}, applyTokens(statusIndicator.label)), "& .MuiChip-icon": Object.assign({ margin: 0, color: "inherit" }, applyTokens(statusIndicator.icon)) }), statusIndicatorColorStyles(color, statusIndicator));
    return _jsx(Chip, Object.assign({ sx: statusIndicatorStyles }, props));
}
export const StatusIndicatorPresets = () => {
    return {
        components: {
            SeverityIndicator: AtlasSeverityIndicator,
            StatusIndicator: AtlasStatusIndicator,
        },
    };
};
//# sourceMappingURL=statusIndicator.js.map